"use strict";
/* --------------------------------------------------------------------------------------------
 *  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */
Object.defineProperty(exports, "__esModule", { value: true });
exports.directoryProviderFactory = directoryProviderFactory;
const ASPNetRuntimeInstallationDirectoryProvider_1 = require("./ASPNetRuntimeInstallationDirectoryProvider");
const RuntimeInstallationDirectoryProvider_1 = require("./RuntimeInstallationDirectoryProvider");
const SdkInstallationDirectoryProvider_1 = require("./SdkInstallationDirectoryProvider");
function directoryProviderFactory(mode, storagePath) {
    return mode === 'runtime' ? new RuntimeInstallationDirectoryProvider_1.RuntimeInstallationDirectoryProvider(storagePath) :
        mode === 'sdk' ? new SdkInstallationDirectoryProvider_1.SdkInstallationDirectoryProvider(storagePath) :
            mode === 'aspnetcore' ? new ASPNetRuntimeInstallationDirectoryProvider_1.ASPNetRuntimeInstallationDirectoryProvider(storagePath)
                : new RuntimeInstallationDirectoryProvider_1.RuntimeInstallationDirectoryProvider(storagePath); // default if no mode is provided - should never happen
}
//# sourceMappingURL=DirectoryProviderFactory.js.map